export * from "./ProviderGuma";
export * from "./useGuma";
// keycloak: https://keycloak.adm.sw01.faber-app.cloud/

// base url : https://guma-base.client.sw01.faber-app.cloud/
// https://guma-base.client.sw01.faber-app.cloud/user/v1/?organizationId=default&showDeleted=false

// tenant/realm : guma-base
// Client Id:
//     guma_application
// Client Secret:
//     bZBjUTBEorXDTuAz5eLKkVxkTaYrZcwB
